<template>
  <div class="checkout-delivery">
    <div class="checkout-delivery__item" v-for="item in pickupItems" :key="item.id" :class="activeType(item.id)" @click="() => {$emit('update:modelValue', item.id)}">
      <div class="checkout-delivery__item-headline">
        {{item.name}}
      </div>
      <div class="checkout-delivery__item-info">
        <span v-for="(span) in item.info"> {{span}}</span>
      </div>
      <div class="checkout-delivery__item-active">
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="3.13523" height="14.9993" rx="1" transform="matrix(0.697214 0.716863 -0.697214 0.716863 13.814 0)" fill="white"/>
          <rect width="3.13523" height="7.88965" rx="1" transform="matrix(-0.697214 0.716863 -0.697214 -0.716863 7.68677 10.7524)" fill="white"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted} from "vue";

export default {
  name: "DeliveryPickup",
  emits: ['update:modelValue'],
  props: ['item', 'modelValue'],
  data() {
    return {
      pickupItems: [
        {
          id: 1,
          name: '1.\tסניף נתניה:',
          info: [
            'הצורן 4, בפסאז\', נתניה',
            'ימי ו\' וערבי חג 9:00-14:00',
            'א\'-ה\' 10:00-19:00'
          ]
        },
        {
          id: 2,
          name: '2.\tסניף תל אביב:',
          info: [
            'שד\' רוקח 67, תל אביב',
            'ימי ו\' וערבי חג 9:00-14:00',
            'א\'-ה\' 10:00-20:00'
          ]
        },
      ]
    }
  },
  methods:{
    activeType(id){
      return {
        active: id === this.modelValue ? 'active' : ""
      }
    }
  },
  mounted() {
    this.$emit('update:modelValue', 1);
  }
}
</script>

<style lang="scss" scoped>
.checkout-delivery {
  display: flex;
  gap: 30px;
  align-items: stretch;
}
@media (max-width: 480px) {
  .checkout-delivery__item {
    height: 168px;
    max-width: 47%;
  }
}
@media (max-width: 321px) {
  .checkout-delivery {
    flex-direction: column;
    &__item {
      max-width: unset;
      height: fit-content;
    }
  }
}
</style>
